import React from 'react';
import Link, { LinkProps } from 'next/link';
import Image from 'next/image';
import styles from './PLPCarouselItem.module.scss';
import Typography from '~/shared/components/Typography/Typography';
import clsx from 'clsx';
import { ImageProps } from '~/shared/components';
import PlaceholderIcon from '~/icons/product-placeholder.svg';

export type PLPCarouselItemProps = LinkProps & {
    className?: string;
    text: string;
    isActive?: boolean;
    image?: ImageProps;
    isPillVariant?: boolean;
};

export const PLPCarouselItem: React.FC<PLPCarouselItemProps> = ({
    className,
    text,
    image,
    href,
    isActive,
    isPillVariant,
    ...rest
}) => {
    const iconSize = isPillVariant ? 20 : 82;

    return (
        <Link
            aria-label={text}
            aria-current={isPillVariant && isActive ? 'page' : undefined}
            className={clsx(
                styles.interactiveElement,
                { [styles.pill]: isPillVariant, [styles.isActive]: isPillVariant && isActive },
                className,
            )}
            href={href}
            title={text}
            {...rest}
        >
            <div className={styles.content}>
                <div className={styles.imageBox}>
                    {image?.src ? (
                        <Image
                            className={styles.image}
                            src={image.src as string}
                            priority
                            alt=""
                            width={iconSize}
                            height={iconSize}
                            quality={75}
                            sizes={`${iconSize}px`}
                        />
                    ) : (
                        <PlaceholderIcon className={styles.image} aria-hidden />
                    )}
                </div>

                <div className={styles.textWrap}>
                    <Typography className={styles.text} as="span" variant="paragraph-S">
                        {text}
                    </Typography>
                </div>
            </div>
        </Link>
    );
};
